import { NgModule } from '@angular/core';

import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '../services/auth-guard';

import {HomeComponent} from '../components/home/home.component';
import {HomeResolve} from '../components/home/home.resolve';

import {AuthComponent} from '../components/auth/auth.component';
import {ProfileComponent} from '../components/profile/profile.component';
import {ContractorComponent} from '../components/contractor/contractor.component';
import {SenderComponent} from '../components/sender/sender.component';
import {TemplateComponent} from '../components/template/template.component';
import {AuditTrailComponent} from '../components/audittrail/audittrail.component';
import {AdministrationComponent} from '../components/admin/admin.component';
import {ExpiredComponent} from '../components/expired/expired.component';
import {ForgotPasswordComponent} from '../components/forgot-password/forgot-password.component';
import {ResetPasswordComponent} from '../components/reset-password/reset-password.component';
import {PIDComponent} from '../components/pid/pid.component';
import {TransferComponent} from '../components/transfer/transfer.component';
import {ContractorUploadComponent} from '../components/contractor-upload/contractor-upload.component';
import {ViewFileComponent} from '../components/view-file/view-file.component';
import {FileDetailsComponent} from '../components/file-details/file-details.component';

const appRoutes: Routes = [
  {path: '', component: HomeComponent, canActivate: [AuthGuard], resolve: { pids: HomeResolve } },
  {path: 'login', component: AuthComponent},
  {path: 'registration', component: AuthComponent},
  {path: 'profile', component: ProfileComponent, canActivate: [AuthGuard] },
  {path: 'contractor', component: ContractorComponent, canActivate: [AuthGuard] },
  {path: 'template', component: TemplateComponent, canActivate: [AuthGuard] },
  {path: 'template/:pid', component: TemplateComponent, canActivate: [AuthGuard] },
  {path: 'audittrail', component: AuditTrailComponent, canActivate: [AuthGuard] },
  {path: 'audittrail/pid/:pid', component: AuditTrailComponent, canActivate: [AuthGuard] },
  {path: 'audittrail/file/:file', component: AuditTrailComponent, canActivate: [AuthGuard] },
  {path: 'sender/:accepted', component: SenderComponent, canActivate: [AuthGuard] },
  {path: 'pid/:id', component: PIDComponent, canActivate: [AuthGuard] },
  {path: 'file/:id/:pid', component: FileDetailsComponent, canActivate: [AuthGuard] },
  {path: 'file/:id/:pid/:version', component: FileDetailsComponent, canActivate: [AuthGuard] },
  {path: 'expired', component: ExpiredComponent},
  {path: 'forgot-password', component: ForgotPasswordComponent},
  {path: 'reset-password/:id/:token', component: ResetPasswordComponent},
  {path: 'contractor-upload/:id/:token', component: ContractorUploadComponent},
  {path: 'contractor-upload/:id/:token/:pid', component: ContractorUploadComponent},
  {path: 'view-file/:id/:token', component: ViewFileComponent},
  {path: 'view-file/:id/:token/:subpid', component: ViewFileComponent},
  {path: 'admin', component: AdministrationComponent, canActivate: [AuthGuard] },
  {path: 'transferred/:id/:token', component: TransferComponent}
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
     
    })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
